export const serializeRepeatParams = (
  params: Record<string, unknown>
): string =>
  Object.entries(params)
    .flatMap(([key, value]) => {
      if (value === null || value === undefined) return [];
      if (Array.isArray(value)) {
        return value.map((v) => `${key}=${encodeURIComponent(String(v))}`);
      }
      return [`${key}=${encodeURIComponent(String(value))}`];
    })
    .join("&");
